export { default as NewTreatingTable } from './NewTreatingTable';
